import React from "react";

function SubNavbar() {
  return (
    <div>
      <div className="sub-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-8">
              <ul className="info">
                <li>
                  <i className="fa fa-envelope" /> info@company.com
                </li>
                <li>
                  <i className="fa fa-map" /> Sunny Isles Beach, FL 33160
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-4">
              <ul className="social-links">
                <li>
                  <a href="https://www.facebook.com/share/17KCf29Vrs/">
                    <i className="fab fa-facebook" />
                  </a>
                </li>
               
                <li>
                  <a href="https://www.linkedin.com/in/abdulrhman-abdelhameed">
                    <i className="fab fa-linkedin" />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/3bdo_abdelhameed_?igsh=MWp2bmRiM2U2NXlxOA==">
                    <i className="fab fa-instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubNavbar;
